exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.app-bar[data-v-6af48b64] .v-toolbar__content {\n  padding: 0;\n}\n.app-logo[data-v-6af48b64] {\n  margin-left: 26px;\n}\n", ""]);
